export const normalizePath = (path)=>decodeURIComponent(path.split("?")[0].toLowerCase());
export const isPathMatched = function(currentPath, linkPath) {
    let matchType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "exact";
    if (matchType === "startsWith") {
        return currentPath.startsWith(linkPath);
    }
    return currentPath === linkPath;
};
